import '.a{display:flex;}.ssr-plugin'
import '.y{flex-direction:row;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.cg{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ax{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.ay{margin-top:2rem;}.ssr-plugin'
import '.az{margin-bottom:5rem;}.ssr-plugin'
import '.b0{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { InitiativeSideBar } from '@app/components/blocks/sidebar/InitiativeSideBar'
import { ClientOnly } from '@based/sdk/react'

export const InitiativeViewPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <div className="a y ae"
      >
        <InitiativeSideBar />
        <div className="cg a c g b"
          style={{
            marginLeft: isMobile ? '3.25rem' : '14rem', // left bar
          }}
        >
          <DashboardNavBar
            initiativeDashboard={true}
            style={{ backgroundColor: 'var(--shades-white)' }}
          />
          <div className="ax a b ab ay az b0"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '60%', // 12rem is padding + navbar height
              paddingInline: isMobile ? '1rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
